import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["src"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import Imgix, { buildURL } from 'react-imgix';
import { replaceAWSSourceWithImgix } from '../helpers/imgix';
export var buildImgixSrc = function buildImgixSrc(src, imgixParams) {
  return buildURL(cleanImgixSrc(src), _objectSpread({}, imgixParams));
};
export var cleanImgixSrc = function cleanImgixSrc(src) {
  var _src;
  // Patching: https://github.com/imgix/react-imgix/issues/801
  // This ternary would be hit if a null or broken src was passed - imgixclient throws a hard error.
  // Instead, replace with a default for now.
  src = (_src = src) !== null && _src !== void 0 && _src.includes('://') ? src : "https://images.dutchie.com/category-stock-photos/flower/flower-1.png";
  // Replace S3 with Imgix
  src = replaceAWSSourceWithImgix(src);
  return src;
};
export var buildImgixSrcSet = function buildImgixSrcSet(src, imgixParams) {
  // Common DPI multipliers (1x, 2x, 3x)
  var dpiMultipliers = [1, 2, 3];
  return dpiMultipliers.map(function (dpi) {
    var dpiParams = _objectSpread(_objectSpread({}, imgixParams), {}, {
      dpr: dpi
    });
    return "".concat(buildImgixSrc(src, dpiParams), " ").concat(dpi, "x");
  }).join(', ');
};
export default /*#__PURE__*/forwardRef(function (_ref, ref) {
  var src = _ref.src,
    props = _objectWithoutProperties(_ref, _excluded);
  src = cleanImgixSrc(src);
  return __jsx(Imgix, _extends({
    ref: ref,
    src: src
  }, props));
});